import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";

export default function CustomAutoComplete({
  params,
  options,
  disabled,
  label,
  width,
  margin = 2,
  pt = 1,
}) {
  return (
    <Autocomplete
      disableClearable
      disabled={disabled}
      options={options}
      value={params.value}
      onChange={params.onChange}
      isOptionEqualToValue={(option, value) => {
        if (!value || value === "" || value.name === "") {
          return true;
        }
        return option.name === value.name;
      }}
      getOptionLabel={(option) => {
        if (option === "") {
          return "";
        }
        return option.name;
      }}
      renderOption={(props, option) => {
        const { key, ...otherProps } = props;
        return (
          <li key={option._id || option.id || option.name} {...otherProps}>
            {option.name}
          </li>
        );
      }}
      sx={{ width, pt, mb: margin }} // Apply bottom margin
      renderInput={(inputParams) => (
        <TextField 
          {...inputParams} 
          label={label}
          error={params.error || undefined}
          helperText={params.error ? params.errorLabel : ""}
        />
      )}
    />
  );
}
